var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 118.6 26.8",
        width: "175",
        height: "40",
      },
    },
    [
      _c("g", { attrs: { id: "EnergySage-logo" } }, [
        _c("path", {
          staticClass: "st0",
          attrs: {
            id: "e_2_",
            d:
              "M1.8 14.2c0 2.8.8 3.4 2.1 3.4 1.1 0 1.7-.9 1.8-1.9h1.8C7.4 18 6 19 3.9 19 1.7 19 0 18.3 0 13.8c0-3 .3-5.4 3.9-5.4 2.9 0 3.6 1.6 3.6 5v.9H1.8m4-1.3c0-3-.8-3.3-2-3.3-1 0-1.9.5-1.9 3.3h3.9z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "st0",
          attrs: {
            id: "n",
            d:
              "M15.8 18.8v-7.1c0-1.1-.4-2-1.8-2-1.8 0-2.1 1.6-2.1 3v6h-1.7v-8.1l-.1-2.1h1.8v1.3h.1c.6-1.2 1.4-1.5 2.7-1.5 2.2 0 2.7 1.3 2.7 3.3v7.1h-1.6",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "st0",
          attrs: {
            id: "e_1_",
            d:
              "M22 14.2c0 2.8.8 3.4 2.1 3.4 1.1 0 1.7-.9 1.8-1.9h1.8c0 2.3-1.4 3.3-3.6 3.3s-3.9-.6-3.9-5.1c0-3 .3-5.4 3.9-5.4 2.9 0 3.6 1.6 3.6 5v.9H22m3.9-1.4c0-3-.8-3.3-2-3.3-1 0-1.9.5-1.9 3.3h3.9z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "st0",
          attrs: {
            id: "r",
            d:
              "M32.1 10.1c.7-1.6 1.6-1.7 3.2-1.7v1.7l-.9-.1c-1.8 0-2.3 1.4-2.3 2.8v6h-1.7V8.6h1.7v1.5",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "st0",
          attrs: {
            id: "g_1_",
            d:
              "M42.5 8.6h1.7v11.2c0 2.3-1.5 2.8-3.8 2.8-1.7 0-3.2-.8-3.1-2.7h1.9c0 .9.6 1.5 1.6 1.5 1.2 0 1.8-.7 1.8-1.8v-2.1h-.1c-.4.8-1.4 1.3-2.2 1.3-2.8 0-3.3-2.4-3.3-5.4 0-4.7 2.4-5 3.2-5 1.1 0 1.9.5 2.4 1.5V8.6m-2 1.2c-1.9 0-1.9 2.3-1.9 3.6 0 3.3.7 4 2 4 2 0 1.9-2.4 1.9-3.8 0-1.5.1-3.8-2-3.8z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "st0",
          attrs: {
            id: "y",
            d: "M50.3 16.9l2.5-8.3h1.8l-4.6 14h-1.8l1.2-3.8-3.5-10.2h2l2.4 8.3",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "st1",
          attrs: {
            id: "s_1_",
            d:
              "M59.2 19c-2.2 0-3.6-1-3.5-3.3h1.9c0 .6 0 2 1.7 2 1 0 1.8-.5 1.8-1.6 0-1.8-5.1-1.9-5.1-4.9 0-1.1.6-2.8 3.5-2.8 1.8 0 3.4.9 3.2 2.9h-1.8c0-1.1-.5-1.6-1.6-1.6-.9 0-1.6.5-1.6 1.4 0 1.8 5.1 1.8 5.1 4.9-.1 2.1-1.6 3-3.6 3",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "st1",
          attrs: {
            id: "a",
            d:
              "M70.4 17.3c-.5 1.2-1.3 1.7-2.6 1.7-2.2 0-2.8-1.4-2.8-3.3 0-3.1 3-3.2 5.3-3.2 0-1.4.1-2.8-1.7-2.8-1.1 0-1.7.7-1.6 1.8h-1.8c.1-2.3 1.3-3.1 3.5-3.1 2.6 0 3.3 1.4 3.3 3.1v4.9l.2 2.4h-1.8v-1.5m-3.7-1.5c0 1 .5 1.9 1.6 1.9 1 0 2.3-.6 2.1-3.9-1.6-.1-3.7-.2-3.7 2z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "st1",
          attrs: {
            id: "g",
            d:
              "M80.6 8.6h1.7v11.2c0 2.3-1.5 2.8-3.8 2.8-1.7 0-3.2-.8-3.1-2.7h1.9c0 .9.6 1.5 1.6 1.5 1.1 0 1.8-.7 1.8-1.8v-2.1h-.1c-.4.8-1.4 1.3-2.2 1.3-2.8 0-3.3-2.4-3.3-5.4 0-4.7 2.4-5 3.2-5 1.1 0 1.9.5 2.4 1.5V8.6m-2 1.2c-1.9 0-1.9 2.3-1.9 3.6 0 3.3.7 4 2 4 2 0 1.9-2.4 1.9-3.8 0-1.5.1-3.8-2-3.8z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "st1",
          attrs: {
            id: "e",
            d:
              "M86.9 14.2c0 2.8.8 3.4 2.1 3.4 1.1 0 1.7-.9 1.8-1.9h1.8c0 2.3-1.4 3.3-3.6 3.3s-3.9-.6-3.9-5.1c0-3 .3-5.4 3.9-5.4 2.9 0 3.6 1.6 3.6 5v.9h-5.7m4-1.4c0-3-.8-3.3-2-3.3-1 0-1.9.5-1.9 3.3h3.9z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "st0",
          attrs: {
            id: "leaf",
            d:
              "M118.6 13.4c0-1.4-.5-2.9-1.5-4.6-.7-1.3-1.8-2.6-3.1-4.1-2.1-2.4-4.3-4.2-4.4-4.3-.3-.3-.7-.4-1.1-.4-.4 0-.8.1-1.1.4-.1.1-2.2 1.9-4.4 4.3a26 26 0 00-3.1 4.1 9.5 9.5 0 00-1.5 4.6 10 10 0 009.2 10V26c0 .5.4.8.8.8.5 0 .8-.4.8-.8v-2.5c5.3-.5 9.4-4.8 9.4-10.1m-10.5 8.4c-4.4-.2-8-3.9-8-8.4 0-4.6 8.4-11.7 8.4-11.7s8.4 7.1 8.4 11.7c0 4.5-3.5 8.1-8 8.4",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "st0",
          attrs: {
            id: "bolt_1_",
            d:
              "M112.5 12.4c-.2-.2-.5-.4-.7-.3l-1.4.2.3-5.8c0-.3-.2-.6-.5-.7h-.3c-.2 0-.4.2-.5.3l-3.6 8.4c-.1.2-.1.6 0 .8.2.2.5.4.7.3l1.4-.2-.9 4.7c0 .3.2.6.5.7H107.8c.2 0 .4-.2.5-.3l4.2-7.3c.2-.3.2-.6 0-.8m-.9.6l-3.6 6.3.9-4.9-2.2.4 3.1-7.4-.3 6 2.1-.4z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }